import React from 'react';
import { buttonStyles } from '../styles/sharedStyles';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  onClick,
  disabled = false,
  type = 'button',
  style = {},
  ...props
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return isHovered && !disabled
          ? { ...buttonStyles.primary, ...buttonStyles.primaryHover }
          : buttonStyles.primary;
      case 'secondary':
        return isHovered && !disabled
          ? { ...buttonStyles.secondary, ...buttonStyles.secondaryHover }
          : buttonStyles.secondary;
      case 'danger':
        return isHovered && !disabled
          ? { ...buttonStyles.danger, ...buttonStyles.dangerHover }
          : buttonStyles.danger;
      case 'success':
        return isHovered && !disabled
          ? { ...buttonStyles.success, ...buttonStyles.successHover }
          : buttonStyles.success;
      case 'outline':
        return isHovered && !disabled
          ? { ...buttonStyles.outline, ...buttonStyles.outlineHover }
          : buttonStyles.outline;
      default:
        return buttonStyles.primary;
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return buttonStyles.small;
      case 'large':
        return buttonStyles.large;
      default:
        return {};
    }
  };

  const combinedStyles = {
    ...buttonStyles.base,
    ...getVariantStyles(),
    ...getSizeStyles(),
    ...(disabled ? buttonStyles.disabled : {}),
    ...style,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={combinedStyles}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
